<template>
  <div v-if="this.options" :style="options.styles">
    <el-form-item
      :label="fieldLabel"
      class="material-style"
    >
      <select-response-auto-complete
        :searchAllColumns="options.searchAllColumns"
        :model="model"
        :columns="columns"
        :api="api"
        :selected="selected"
        :fields="fields"
        :placeholder="placeholder"
        :templateFilter="templateFilter"
        @on-change="handleChange"
        @clear="handleReset"
      >
      </select-response-auto-complete>
    </el-form-item>
  </div>
</template>

<script>
import { mixFilters } from '../mixin'

export default {
  name: 'NewFilterSelectAutoComplete',
  mixins: [mixFilters],
  props: {
    config: { type: Object, default: () => {} }
  },
  data () {
    return {
      model: '',
      options: this.ModelConfig(),
      currentTarget: {}
    }
  },
  computed: {
    api () {
      return this.options.dataSource.url
    },
    selected () {
      return this.options.dataSource.selected
    },
    columns () {
      return this.options.columns.map((column) => {
        return {
          ...column,
          title: this.checkEs6AndRun(column.title)
        }
      })
    },
    fields () {
      const { value: id, label: title } = this.options.option
      return {
        id,
        title
      }
    },
    placeholder () {
      return this.checkEs6AndRun(this.options.placeholder)
    },
    templateFilter () {
      return this.options.templateFilter
    }
  },
  methods: {
    ModelConfig () {
      return {
        // eslint-disable-next-line
        valueTemplate: '(${data.field} == ${isNaN(Number(data.value)) ? `"${data.value}"` : data.value})',
        templateFilter: undefined,
        value: '',
        dataSource: {
          url: '',
          selected: '',
          filters: '',
          take: '',
          orderBy: ''
        },
        columns: [],
        searchAllColumns: false,

        placeholder: this.L10n('select'),
        classes: '',
        styles: {},
        size: '',

        option: {
          label: 'title',
          value: 'id',
          template: null
        }
      }
    },
    handleChange (model = null, currentTarget = {}) {
      this.model = model
      this.currentTarget = currentTarget
      this.updateRendered()
      this.handle('change')
    },
    handleReset () {
      this.handleChange()
    },
    handleClear () {
      this.handleChange()
    },
    // FROM MIXINS
    parseConfig (Options) {
      this.handle('parseStart')
      // reset data
      this.options = null
      this.model = ''
      // update options
      this.options = this.$_.merge(this.ModelConfig(), this.config.options, Options || {})
      // update filters query
      this.updateRendered()
      this.handle('parseEnd')
      this.updateRendered()
      // Load data
      this.handle('init')
    },
    updateRendered () {
      this.result = this.options.value
      this.resultHuman = ''
      if (this.model) {
        this.result = this.createValue({
          field: this.config.field,
          value: this.model,
          dataValue: this.currentTarget
        }, this)
        this.resultHuman = this.model
      }
    }
  }
}
</script>
